import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { AccountCircle, Assessment, Assignment, Dashboard, ExitToApp, ListAlt, MonetizationOn, PermIdentity, Person, PersonAdd, ReceiptSharp, Settings, TransferWithinAStation, VerifiedUser, VerticalAlignBottom, VerticalAlignTop } from '@material-ui/icons';
import MenuIcon from '@material-ui/icons/Menu';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearToken, getTokenValue } from '../../helpers/utility';
import logo from "../../images/logo.png";
import { getAccessToken } from '../../store/authentication/auth.selector';

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#010e24',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        zIndex: 9999,
        background: 'linear-gradient(90deg, #010e24 0%, #01295C 100%)',
        boxShadow: '0 2px 12px rgba(0,0,0,0.4)',
        borderBottom: '1px solid rgba(238,54,56,0.25)',
    },
    menuButton: {
        marginRight: theme.spacing(2),
        color: '#fff',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
        background: 'linear-gradient(180deg, #010e24 0%, #01295C 40%, #0d1f4a 100%)',
        color: '#c7d2dc',
        borderRight: '1px solid rgba(255,255,255,0.07)',
        overflowX: 'hidden',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(1),
        paddingTop: 0,
        background: '#010e24',
        minHeight: '100vh'
    },
}));

function ResponsiveDrawer(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const { window } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const { accessToken } = useSelector((state) => {
        return {
            accessToken: getAccessToken(state),
        }
    });

    const user = getTokenValue(accessToken);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const navItemClass = (path) => `py-1 pl-4 ${location.pathname === path || (path !== '/' && location.pathname.startsWith(path)) ? 'nav-item-active' : ''}`;

    const drawer = (
        <div>
            <Hidden mdDown implementation="css">
                <Typography variant="h6" noWrap className='text-center admin-logo'>
                    <img src={logo} height={72} className='mt-2' alt="Team369" />
                    <span className="admin-brand-name">Team 369</span>
                    <span className="admin-brand-tagline">Welcome to admin console</span>
                </Typography>
            </Hidden>
            <Hidden smUp implementation="css">
                <div className={classes.toolbar} />
            </Hidden>
            <List disablePadding className='admin-nav-list'>
                <ListItem disableGutters className={navItemClass('/')} button onClick={() => navigate("/")}>
                    <ListItemIcon>
                        <Dashboard />
                    </ListItemIcon>
                    <ListItemText primary={"Dashboard"} />
                </ListItem>
                <ListItem disableGutters className={navItemClass('/profile')} button onClick={() => navigate("/profile")}>
                    <ListItemIcon>
                        <AccountCircle />
                    </ListItemIcon>
                    <ListItemText primary={"Profile"} />
                </ListItem>
                {
                    user.role === "Super Admin" && <ListItem disableGutters className={navItemClass('/users')} button onClick={() => navigate("/users")}>
                        <ListItemIcon>
                            <PersonAdd />
                        </ListItemIcon>
                        <ListItemText primary={"Users"} />
                    </ListItem>
                }
                {
                    (user.role === "Super Admin" || user.role === "Member Admin") &&
                    <ListItem disableGutters className={navItemClass('/members')} button onClick={() => navigate("/members")}>
                        <ListItemIcon>
                            <Person />
                        </ListItemIcon>
                        <ListItemText primary={"Members"} />
                    </ListItem>
                }
                {
                    (user.userId === "USR056314") &&
                    <ListItem disableGutters className={navItemClass('/kyc')} button onClick={() => navigate("/kyc")}>
                        <ListItemIcon>
                            <VerifiedUser />
                        </ListItemIcon>
                        <ListItemText primary={"KYC Verification"} />
                    </ListItem>
                }
                {
                    (user.role === "Super Admin" || user.role === "Transaction Admin") &&
                    <ListItem disableGutters className={navItemClass('/memberTransactions')} button onClick={() => navigate("/memberTransactions")}>
                        <ListItemIcon>
                            <PermIdentity />
                        </ListItemIcon>
                        <ListItemText primary={"Member Permission"} />
                    </ListItem>
                }
                {
                    (user.role === "Super Admin" || user.role === "Member Admin") &&
                    <ListItem disableGutters className={navItemClass('/planMembers')} button onClick={() => navigate("/planMembers")}>
                        <ListItemIcon>
                            <ListAlt />
                        </ListItemIcon>
                        <ListItemText primary={"Member Plans"} />
                    </ListItem>
                }
                <ListItem disableGutters className={navItemClass('/plans')} button onClick={() => navigate("/plans")}>
                    <ListItemIcon>
                        <ListAlt />
                    </ListItemIcon>
                    <ListItemText primary={"Plan Calculator"} />
                </ListItem>
                {
                    (user.role === "Super Admin" || user.role === "Transaction Admin") &&
                    <ListItem disableGutters className={navItemClass('/buy-transactions')} button onClick={() => navigate("/buy-transactions")}>
                        <ListItemIcon>
                            <VerticalAlignTop />
                        </ListItemIcon>
                        <ListItemText primary={"Buy Transactions"} />
                    </ListItem>
                }
                {
                    (user.role === "Super Admin" || user.role === "Transaction Admin") &&
                    <ListItem disableGutters className={navItemClass('/sell-transactions')} button onClick={() => navigate("/sell-transactions")}>
                        <ListItemIcon>
                            <VerticalAlignBottom />
                        </ListItemIcon>
                        <ListItemText primary={"Sell Transactions"} />
                    </ListItem>
                }
                {
                    (user.role === "Super Admin" || user.role === "Transaction Admin") &&
                    <ListItem disableGutters className={navItemClass('/withdraws')} button onClick={() => navigate("/withdraws")}>
                        <ListItemIcon>
                            <TransferWithinAStation />
                        </ListItemIcon>
                        <ListItemText primary={"Withdraws"} />
                    </ListItem>
                }
                {
                    (user.role === "Super Admin" || user.role === "Transaction Admin") &&
                    <ListItem disableGutters className={navItemClass('/contracts')} button onClick={() => navigate("/contracts")}>
                        <ListItemIcon>
                            <Assignment />
                        </ListItemIcon>
                        <ListItemText primary={"Contracts"} />
                    </ListItem>
                }
                {
                    (user.role === "Super Admin" || user.role === "Transaction Admin") &&
                    <ListItem disableGutters className={navItemClass('/payouts')} button onClick={() => navigate("/payouts")}>
                        <ListItemIcon>
                            <MonetizationOn />
                        </ListItemIcon>
                        <ListItemText primary={"Payouts"} />
                    </ListItem>
                }
                {
                    (user.role === "Super Admin" || user.role === "Transaction Admin") &&
                    <ListItem disableGutters className={navItemClass('/recharges')} button onClick={() => navigate("/recharges")}>
                        <ListItemIcon>
                            <ReceiptSharp />
                        </ListItemIcon>
                        <ListItemText primary={"Recharges"} />
                    </ListItem>
                }
                {
                    (user.role === "Super Admin" || user.role === "Report Admin") &&
                    <ListItem disableGutters className={navItemClass('/reports')} button onClick={() => navigate("/reports")}>
                        <ListItemIcon>
                            <Assessment />
                        </ListItemIcon>
                        <ListItemText primary={"Reports"} />
                    </ListItem>
                }
                {
                    (user.role === "Super Admin") &&
                    <ListItem disableGutters className={navItemClass('/settings')} button onClick={() => navigate("/settings")}>
                        <ListItemIcon>
                            <Settings />
                        </ListItemIcon>
                        <ListItemText primary={"Settings"} />
                    </ListItem>
                }
                <ListItem disableGutters className='py-1 pl-4 nav-logout-item' button onClick={() => {
                    clearToken();
                }}>
                    <ListItemIcon>
                        <ExitToApp />
                    </ListItemIcon>
                    <ListItemText primary={"Logout"} />
                </ListItem>
            </List>
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <div className={`${classes.root} admin-shell`}>
            <CssBaseline />
            <Hidden smUp implementation="css">
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            className={classes.menuButton}
                        >
                            <MenuIcon />
                        </IconButton>
                        <img src={logo} height={40} alt="Team369" />&nbsp;
                        <h3 className='m-0 p-0'>Team 369</h3>
                    </Toolbar>
                </AppBar>
            </Hidden>
            <nav className={classes.drawer} aria-label="mailbox folders">
                <Hidden smUp implementation="css">
                    <Drawer
                        container={container}
                        variant="temporary"
                        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        ModalProps={{
                            keepMounted: true,
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        variant="permanent"
                        open
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
            </nav>
            <main className={`${classes.content} admin-main`}>
                <Hidden smUp implementation="css">
                    <div className={classes.toolbar} />
                </Hidden>
                {props.children}
            </main>
        </div >
    );
}

ResponsiveDrawer.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default ResponsiveDrawer;
